import { store } from 'src/stores';

import { onBoardingActions } from '../reducers';

export const onChangeStep = (step: { id: string, question: string }) => () => {
  store.dispatch(onBoardingActions.changeCurrentStep(step))
};
